"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find = exports.lstat = exports.readdir = void 0;
const fs_1 = require("fs");
const path_1 = require("path");
const common_1 = require("./common");
const debug_1 = require("./debug");
const extract_1 = require("./extract");
exports.readdir = fs_1.promises.readdir, exports.lstat = fs_1.promises.lstat;
async function find(src) {
    const fileResults = [];
    const archiveResults = [];
    await traverse(src, async (path, stats) => {
        if (!common_1.isSupportedSize(stats.size)) {
            return;
        }
        if (extract_1.isArchive(path)) {
            archiveResults.push(path);
            return;
        }
        fileResults.push(path);
    });
    return [fileResults, archiveResults];
}
exports.find = find;
async function traverse(src, handle) {
    try {
        const stats = await exports.lstat(src);
        if (stats.isSymbolicLink()) {
            return;
        }
        if (stats.isFile()) {
            handle(src, stats);
            return;
        }
        if (stats.isDirectory()) {
            const entries = await exports.readdir(src);
            for (const entry of entries) {
                const absolute = path_1.join(src, entry);
                await traverse(absolute, handle);
            }
        }
    }
    catch (error) {
        debug_1.debug(error.message || `Error reading file ${src}. ${error}`);
    }
}
//# sourceMappingURL=find.js.map